export const projects = [
    {
        image: '../../../assets/images/project_1.png',
        title: 'Hashreels: A collection of Sci-Fi themed shorts written and produced for the Web3 community',
        description: 'Our Pilot Series Hashreels, will provide you with a selection of exclusive Sci-Fi and Web3-themed shorts - All created by award- winning screenwriters and groundbreaking talent from the global Entertainment Industry. Episode 1 is already online and ready for funding. Check it out now!'
    },
    // {
    //     image: '../../../assets/images/project_2.png',
    //     title: 'Collection Name',
    //     description: 'Our Pilot Series Hashreels, will provide you with a selection of exclusive Sci-Fi and Web3-themed shorts - All created by award- winning screenwriters from the global Entertainment Industry. Episode 1 is already online and ready for funding. Check it out now!'
    // }
]
